/**
 * Right Message Script
 */

if ( window.personalizeCity === true ) {
    fetch('https://ipapi.co/json/')
        .then( (response) => {
            response.json().then( data => {
                window.geolocation = data;
                loadRM();
            })
        }).catch( (error) => {
            console.log(error);
            loadRM();
        });
} else {
    loadRM();
}

function loadRM() {
    (function(p, a, n, d, o, b, c) {
        o = n.createElement('script'); o.type = 'text/javascript'; o.async = true; o.src = 'https://t.rightmessage.com/'+p+'.js';
        b = n.getElementsByTagName('script')[0]; d = function(h, u, i) { var c = n.createElement('style'); c.id = 'rmcloak'+i;
            c.type = 'text/css'; c.appendChild(n.createTextNode('.rmcloak'+h+'{visibility:hidden}.rmcloak'+u+'{display:none}'));
            b.parentNode.insertBefore(c, b); return c; }; c = d('', '-hidden', ''); d('-stay-invisible', '-stay-hidden', '-stay');
            setTimeout(o.onerror = function() { c.parentNode && c.parentNode.removeChild(c); }, a); b.parentNode.insertBefore(o, b);
    })('856265991', 20000, document);
}